export const drawerWidth = 240;

export const getDefaultConfigObj = () => ({
  currentPage: 1,
  totalPages: 0,
  pageSize: 10,
  showArchivedData: false,
});
